module.exports = __webpack_public_path__ + "img/tools-icon.ef100faf.png";